import GateKeeperMiddleware from '@/middleware/GateKeeperMiddleware.js';
import { canViewStudentSupportDashboard } from '@/policies/StudentSupportDashboardPolicy.js';

export default [
    {
        path: '/dashboards',
        component: () => import('@/pages/dashboards/Dashboards.vue'),
        name: 'dashboards',
        meta: {
            title: 'Dashboards',
            middleware: [GateKeeperMiddleware],
            ability: ({ gateKeeper, to }) =>
                canViewStudentSupportDashboard(gateKeeper.user) ||
                gateKeeper.userHasPermission('view a dashboard') ||
                gateKeeper.userHasPermission('view insight dashboard') ||
                gateKeeper.userHasGroupPermission('view insight dashboard') ||
                gateKeeper.userIsGroupInstructor(),
        },
    },
];
